"use client";

import { useEffect, useState } from "react";

/**
 * Client component to detect if we're on an embed route
 * and hide header/footer via CSS
 */
export function EmbedRouteDetector() {
  const [isEmbedRoute, setIsEmbedRoute] = useState(false);

  useEffect(() => {
    // Check if current pathname includes /embed/
    const pathname = window.location.pathname;

    setIsEmbedRoute(pathname.includes("/embed/"));
  }, []);

  useEffect(() => {
    if (isEmbedRoute) {
      // Hide header and footer by adding a class to body
      document.body.classList.add("embed-route");

      return () => {
        document.body.classList.remove("embed-route");
      };
    }
  }, [isEmbedRoute]);

  return null;
}
